<template>
  <div v-if="show" class="summary-modal">
    <div class="summary-content">
      <h3>Biochar Facility Analysis</h3>
      <p>
        <b>Analysis within {{ radius }} {{ unit }}</b>
      </p>
      <p>Number of Processing Factories: {{ factoryCount }}</p>
      <p>
        Annual Maize Production Value: {{ formatNumber(maizeProduction) }} tonnes
      </p>
      <p>
        Annual PKS Production Value: {{ formatNumber(pksProduction) }} tonnes
      </p>
      <p>
        Annual Factory Waste Production Value: 0 tonnes
      </p>
      <p>
        Total Feedstock Available per Year:
        {{ formatNumber(totalFeedstockAvailable) }} tonnes
      </p>
      <p>
        Factory Processed Capacity per Year:
        {{ formatNumber(factoryInputCapacity) }} tonnes
      </p>
      <p>
        Maximum Biochar Output per Year:
        {{ formatNumber(maxBiocharOutput) }} tonnes
      </p>
      <p>Factory Utilization: {{ formatNumber(factoryUtilization) }}%</p>
      <p>Production Status: {{ productionStatus }}</p>
      <button @click="closeModal">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BiocharAnalysisSummary",
  props: {
    show: Boolean,
    factoryCount: Number,
    totalFeedstockAvailable: Number, 
    maizeProduction: Number,
    pksProduction: Number,  
    factoryInputCapacity: Number,
    maxBiocharOutput: Number,
    factoryUtilization: Number,
    productionStatus: String,
    radius: Number,
    unit: String,
  },
  methods: {
    formatNumber(value) {
      const num = parseFloat(value);
      return isNaN(num)
        ? "0"
        : num.toLocaleString("en-US", { maximumFractionDigits: 2 });
    },
    closeModal() {
      this.$emit("close");
      if (this.$parent.view && this.$parent.view.popup) {
        this.$parent.view.popup.close(); 
      }
      if (this.$parent.bufferLayer) {
        this.$parent.bufferLayer.removeAll();
      }
      // Reset buffer state and currentBufferGraphic to keep buffer visible
      this.$parent.isBufferActive = false;
      this.$parent.bufferCenter = null;
      this.$parent.bufferRadiusMeters = null;
    },
  },
};
</script>

<style scoped>
.summary-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: transparent; */
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  z-index: 1000;
  pointer-events: none
}
.summary-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 3rem 5rem rgba(0, 0, 0, 0.3);
  text-align: left;
  width: 350px;
  margin: 20px;
  max-width: 500px;
  pointer-events: auto
}
button {
  margin-top: 10px;
  padding: 8px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #3e8e41;
}
</style>
